export function setLoading(isLoading) {
  return {
    type: 'SET_LOADING',
    isLoading
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/PageLoader/actions.js